import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import BannerHomeV2 from './components/BannerHomeV2/BannerHomeV2';
import bannerDataMock from './components/BannerHomeV2/bannerHomeDataMock.json';

ReactDOM.render(
    <BannerHomeV2
        data={bannerDataMock}
        dataLength={bannerDataMock.length}
    />, document.getElementById('bannerHomeComponentMDB')
);